import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    width: '600px',
  },
  logo: {
    width: '70%',
    margin: 'auto',
  },
  statusMessage: {
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '-10px'
  }
}));

export default styles;
